import React from 'react';

import PermissionGate from '@src/components/PermissionGate';
import AccountContainer from '@src/containers/Accounts';
import { PERMISSIONS } from '@src/constants';

const Permissions = () => (
  <PermissionGate
    requiredPermissions={[PERMISSIONS.VIEW_ACCOUNT, PERMISSIONS.MANAGE_ACCOUNT]}
  >
    <AccountContainer />
  </PermissionGate>
);

export default Permissions;
